/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NotificationTemplateResponseItem } from './notification-template-response-item';


export interface NotificationInfoResponse { 
    id?: string;
    identifier?: string | null;
    description?: string | null;
    groupId?: number;
    templates?: Array<NotificationTemplateResponseItem> | null;
}

